const $element = $('.js-delivery-moment');
const $picker = $('.js-delivery-moment-picker');

const deliveryMoment = {
  initialize() {
    if ($element.length) {
      this.createListeners();

      this.togglePicker($element.find('.js-delivery-moment-custom-date')[0].checked);
    }
  },

  createListeners() {
    $element.on('change', 'input', (e) => {
      const $target = $(e.currentTarget);

      this.togglePicker($target.val() === 'custom_date' && $target[0].checked);
    });
  },

  togglePicker(state) {
    if (state) {
      $picker.show();
      $picker.find('.js-datepicker').prop('required', true);
    } else {
      $picker.hide();
      $picker.find('.js-datepicker').prop('required', false);
    }
  },
};

export default deliveryMoment;
